import React, {useContext, useEffect, useReducer, useState} from 'react';
import axios from 'axios';
import classes from './ProductCategoryPage.module.scss';
import classesFilter from './ProductFilter/ProductFilter.module.scss';
import JIcon from "../../components/UI/Icon/JIcon";
import scrollToComponent from "react-scroll-to-component";
import {Helmet} from "react-helmet";
import ReactGa from "react-ga";
import {HomeBreadcrumb} from "../../components/UI/HomeButton";
import ContactUs from "../../components/ContactUs";
import {utilScrollUp} from "../../utils/Utils";
import CountSortingContainer from "../../components/UI/CountSortingContainer/CountSortingContainer";
import {isMobileOnly, isTablet} from "react-device-detect";
import Pagination from "../../components/UI/Pagination/Pagination";
import Product from "./Products/Product/Product";
import update from 'immutability-helper';
import CategoriesHook from "../FeaturedPage/Categories/CategoriesHook";
import {LoadingSimple} from "../../components/UI/LoadingBar";
import {FormattedMessage} from "react-intl";
import {Context} from "../../context/Wrapper";

const initialState = {
    selectedCategory: [],
    selectedSubCategories: [],
    selectedProductBrands: [],
    products: [],
    productCategories: [],
    isLoading: false,
    isLoadingProducts: false
    , defaultOps: 0
    , postPerPage: isMobileOnly || isTablet ? 12 : 15
    , currentPage: 1

    , tempProducts: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_DATA':
            return {
                ...state
                , selectedCategory: action.category
                , productCategories: action.productCategories
                , selectedSubCategories: action.selectedSubCategories
                , selectedProductBrands: action.selectedProductBrands
                , products: action.products
                , tempProducts: action.tempProducts
                , defaultOps: 0
                , currentPage: 1
                , isLoading: action.isLoading
                , isLoadingProducts: action.isLoadingProducts
            }
        case 'FETCH_SUB_CATEGORIES':
            return {
                ...state
                , selectedSubCategories: action.payload
            }
        case 'FETCH_BRANDS':
            return {
                ...state
                , selectedProductBrands: action.payload
            }
        case 'FETCH_PRODUCTS':
            return {
                ...state
                , products: action.payload
                , currentPage: 1
                , defaultOps: 0
                , isLoadingProducts: action.isLoadingProducts
            }
        case 'SORTING_PRODUCTS':
            return {
                ...state
                , products: action.payload
                , defaultOps: action.defaultOps
            }
        case 'ORIGIN_PRODUCTS':
            return {
                ...state
                , products: action.tempProducts
                , defaultOps: action.defaultOps
            }
        case 'IS_LOADING':
            return {
                ...state
                , isLoading: action.payload
            }
        case 'IS_LOADING_PRODUCTS':
            return {
                ...state
                , isLoadingProducts: action.isLoadingProducts
            }
        case 'PAGE_SETTINGS':
            return {
                ...state
                , currentPage: action.currentPage
            }
        case 'DEFAULT_OPS':
            return {
                ...state
                , defaultOps: action.payload
            }
        default:
            return state
    }
}

const ProductCategoryPageHook = (props) => {
    const context = useContext(Context);

    const [options] = useState([
        {displayId: '-Pilih-', displayValue: '-Choose Sorting-', value: 0},
        {displayId: 'Nama (A-z)', displayValue: 'Name (A-z)', value: 1},
        {displayId: 'Nama (Z-a)', displayValue: 'Name (Z-a)', value: 2},
        {displayId: 'Produk Baru', displayValue: 'New Products', value: 3},
        {displayId: 'Produk Favorit', displayValue: 'Favourite', value: 4},
    ])

    const [isError, setIsError] = useState(false);
    const [initEffect, setInitEffect] = useState(null);
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        //============================================================
        // console.log('useEffect 1');
        //============================================================
        ReactGa.pageview(window.location.origin.toString() + props.location.pathname);
        const loadDocumentTitle = () => {
            document.title =
                localStorage.getItem('ct_param_product_category')
                && localStorage.getItem('ct_param_product_category') !== null ?
                    `${localStorage.getItem('ct_param_product_category')}${(" Catalog Japfa Food | Indonesia | Food Supplier")}`
                    :
                    'Catalog Japfa Food | Indonesia | Food Supplier'
        }
        window.scrollTo(0, 0);

        const ourRequest = axios.CancelToken.source() // <-- 1st step
        const fetchProdCategories = async () => {
            dispatch({type: 'IS_LOADING_PRODUCTS', isLoadingProducts: true})
            const header = {headers: {'language': context.locale}};
            const product_category = await axios.get('product_category/' + props.match.params.id, header, {cancelToken: ourRequest.token,});
            // const paramId = product_category.data.id;
            const paramId = product_category.data.product_category_cd;
            const product_categories = await axios.get('product_categories', header, {cancelToken: ourRequest.token,});
            const product_sub_categories = await axios.get('product_sub_categories/' + paramId, header, {cancelToken: ourRequest.token,});
            const product_sub_categories_checkbox = product_sub_categories.data && product_sub_categories.data.product_sub_categories.map(x => {
                return {...x, is_checked: false}
            });
            const immutablySelectedSubCategories = getImmutablyCheckedData(product_sub_categories_checkbox, 'slug', null);
            const product_brands = await axios.get('product_brands/' + paramId, header, {cancelToken: ourRequest.token,});
            // const product_brand_checkbox = product_brands.data.product_brands.filter(x => x.id !== 10).map(x => {
            const product_brand_checkbox = product_brands.data.product_brands && product_brands.data.product_brands.filter(x => x.product_brand_cd !== 'BR0010').map(x => {
                return {...x, is_checked: false}
            });

            //setStates
            // const get_products = await axios.get('products/' + product_category.data.id, header)
            const get_products = await axios.get('products/' + paramId, header)

            dispatch({
                type: 'FETCH_DATA',
                category: product_category && product_category.data
                , productCategories: product_categories.data.product_categories && product_categories.data.product_categories.filter(x => x.slug !== props.match.params.id)
                , selectedSubCategories: immutablySelectedSubCategories
                , selectedProductBrands: product_brand_checkbox
                , products: props.match.params.sub_category_slug !== undefined ?
                    get_products && get_products.data.products.filter(data => data.product_sub_category_slug === props.match.params.sub_category_slug) : get_products.data.products
                , defaultOps: 0
                , currentPage: 1
                , tempProducts: get_products.data.products
                , isLoading: false
                , isLoadingProducts: false
            })
            autoSelectSubCategory(immutablySelectedSubCategories)
        }
        fetchProdCategories();
        loadDocumentTitle();
        setInitEffect(null)

        //hooks cleanup
        return () => {
            ourRequest.cancel() // <-- 3rd step
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.match.params.id, props.match.params.sub_category_slug, props.location.pathname, props.history, context.locale]);

    useEffect(() => {
        //============================================================
        // console.log('useEffect 2');
        //============================================================
        const ourRequest = axios.CancelToken.source() // <-- 1st step
        const fetchFilterProducts = async () => {
            const header = {headers: {'language': context.locale}};

            const data = new FormData();
            data.append('product_category_cd', state.selectedCategory.product_category_cd);
            state.selectedSubCategories.filter(x => x.is_checked === true).map(x => {
                // data.append('product_sub_category_id[]', x.id);
                data.append('product_sub_category_cd[]', x.product_sub_category_cd);
                return null;
            });

            state.selectedProductBrands.filter(x => x.is_checked === true).map(x => {
                // data.append('product_brand_id[]', x.id);
                data.append('product_brand_cd[]', x.product_brand_cd);
                return null;
            });
            const get_products = await axios.post('product_filter', data, header)

            // setProducts(get_products.data.products)
            dispatch({
                type: 'FETCH_PRODUCTS',
                payload: get_products.data && get_products.data.products.length > 0 ? get_products.data.products : [{id: null}]
                , tempProducts: get_products.data.products
            })
        }
        try {
            /*---------------------------------------------------------------------------------------
              @desc: fetchFilterProducts akan dieksekusi ketika dari Header Menu dipilih sub category
            * ---------------------------------------------------------------------------------------*/
            if (initEffect !== null) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                fetchFilterProducts();
            } else {
                return;
            }
        } catch (e) {
            setIsError(true)
            setInitEffect(null)
        }

        //hooks cleanup
        return () => {
            ourRequest.cancel() // <-- 3rd step
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.selectedSubCategories, state.selectedProductBrands])

    const autoSelectSubCategory = (selectedSubCategories) => {
        const subCategoryIndex = selectedSubCategories.findIndex(x => x.slug === props.match.params.sub_category_slug);
        const newData = update(selectedSubCategories[subCategoryIndex], {
            is_checked: {$set: true}
        });
        const subCategoriesWithUpdated = [...selectedSubCategories];
        subCategoriesWithUpdated[subCategoryIndex] = newData;
        dispatch({type: 'FETCH_SUB_CATEGORIES', payload: subCategoriesWithUpdated});
    }

    const getImmutablyCheckedData = (sourceData, paramKey, paramSubCategorySlug) => {
        const indexOfData = (paramKey === 'slug' ?
            sourceData.findIndex(x => x.slug === paramSubCategorySlug) :
            sourceData.findIndex(x => x.product_sub_category_cd === paramSubCategorySlug));
        const selectedDataByIndex = {...sourceData[indexOfData]}
        selectedDataByIndex.is_checked = (!!paramSubCategorySlug); //!! Double Bang is casting to Boolean
        const mergeDataInList = [...sourceData];
        mergeDataInList[indexOfData] = selectedDataByIndex;
        return mergeDataInList;
    }

    const onFilterHandler = (event, paramTypeList) => {
        if (paramTypeList === 'sub_category') {
            const subCategoryIndex = state.selectedSubCategories.findIndex(x => x.slug === event.target.value);
            const newData = update(state.selectedSubCategories[subCategoryIndex], {
                is_checked: {$set: event.target.checked}
            });
            const subCategoriesWithUpdated = [...state.selectedSubCategories];
            subCategoriesWithUpdated[subCategoryIndex] = newData;
            dispatch({type: 'FETCH_SUB_CATEGORIES', payload: subCategoriesWithUpdated});
        }

        if (paramTypeList === 'brand') {
            const brandIndex = state.selectedProductBrands.findIndex(x => x.slug === event.target.value);
            const newBrand = update(state.selectedProductBrands[brandIndex], {
                is_checked: {$set: event.target.checked}
            });
            const brandWithUpdated = [...state.selectedProductBrands];
            brandWithUpdated[brandIndex] = newBrand;
            dispatch({type: 'FETCH_BRANDS', payload: brandWithUpdated})
        }
        setInitEffect(true)
    }

    const gotoSomewhere = () => {
        props.history.push('/featured-products');
    }
    const onRefreshHandler = (category_slug, category_id, sub_category_slug, sub_category_id, category_title) => {
        localStorage.setItem("selected_category_id", category_id);
        localStorage.setItem("selected_category", category_slug);
        localStorage.setItem("selected_sub_category", sub_category_slug);
        localStorage.setItem("selected_sub_category_id", sub_category_id);
        localStorage.setItem('ct_param_product_category', category_title)
        props.history.replace('/product-categories/' + category_slug);
        // setCurrentPage(1)
    }
    const onSortHandler = (event) => {
        const value = event.target.value;
        switch (+value) {
            case (1) :
                dispatch({
                    type: 'SORTING_PRODUCTS', payload: state.products.sort((a, b) => +(a.name > b.name) || -(a.name < b.name)),
                    defaultOps: value
                })
                break
            case (2) :
                dispatch({
                    type: 'SORTING_PRODUCTS', payload: state.products.sort((a, b) => +(a.name < b.name) || -(a.name > b.name)),
                    defaultOps: value
                })
                break
            case (3) :
                dispatch({
                    type: 'SORTING_PRODUCTS', payload: state.products.sort((a, b) =>
                        +(a.is_new_product < b.is_new_product) || -(a.is_new_product > b.is_new_product) ||
                        -(a.is_fav_product < b.is_fav_product) || +(a.is_fav_product > b.is_fav_product)),
                    defaultOps: value
                })
                break
            case (4) :
                dispatch({
                    type: 'SORTING_PRODUCTS', payload: state.products.sort((a, b) =>
                        +(a.is_fav_product < b.is_fav_product) || -(a.is_fav_product > b.is_fav_product) ||
                        +(a.is_new_product < b.is_new_product) || -(a.is_new_product > b.is_new_product)),
                    defaultOps: value
                })
                break
            case (0) :
                dispatch({
                    type: 'SORTING_PRODUCTS',
                    payload: state.products.sort((a, b) => +((a.product_cd) < (b.product_cd)) || -((a.product_cd) > (b.product_cd))),
                    defaultOps: value
                })
                break
            default:
                return state.products;
        }
    }


    // --------------------------------------------------
    let localSubCategory;
    let localProductBrand;
    let otherCategories;
    let localProducts;
    let contactUsComponent = <p>Load...</p>

    let pagination;
    // --------------------------------------------------
    const indexOfLastData = state.currentPage * state.postPerPage;
    const indexOfFirstData = indexOfLastData - state.postPerPage;
    const currentData = state.products !== undefined ?
        state.products.slice(indexOfFirstData, indexOfLastData) : [];
    const paginate = (pageNumber) => {
        dispatch({type: 'PAGE_SETTINGS', currentPage: pageNumber});
        utilScrollUp()
    };
    const paginateNext = () => {
        dispatch({type: 'PAGE_SETTINGS', currentPage: state.currentPage + 1});
        utilScrollUp()
    };
    const paginatePrev = () => {
        dispatch({type: 'PAGE_SETTINGS', currentPage: state.currentPage - 1});
        utilScrollUp()
    };
    const pageStart = (pageNumber) => {
        dispatch({type: 'PAGE_SETTINGS', currentPage: pageNumber});
        utilScrollUp()
    };
    const pageEnd = (pageNumber) => {
        dispatch({type: 'PAGE_SETTINGS', currentPage: pageNumber});
        utilScrollUp()
    };
    pagination = <Pagination postPerPage={state.postPerPage}
                             totalData={state.products !== undefined ? state.products.length : []}
                             currentPage={state.currentPage}
                             paginate={paginate}
                             paginateNext={paginateNext}
                             paginatePrev={paginatePrev}
                             pageStart={pageStart}
                             pageEnd={pageEnd}/>;


    if (state.selectedCategory) {

        contactUsComponent = (
            // <ContactUs buttonTitle={"Contact Our Sales"}
            <ContactUs buttonTitle={<FormattedMessage id={"prodcategory.contactus"} defaultMessage={"Contact Our Sales"}/>}
                       width={18}
                       productCategorySelected={state.selectedCategory}
                       paramMessage={state.selectedCategory.name}/>);

        if (state.selectedSubCategories && state.selectedSubCategories) {
            localSubCategory = state.selectedSubCategories.map((sub_category, index) => {
                return (
                    <li key={`${sub_category.id}${index}`}>
                        <div className={classesFilter.Filter_checkbox_label}>
                            <input type="checkbox"
                                   id={sub_category.product_sub_category_cd}
                                   checked={sub_category.is_checked}
                                   value={sub_category.slug}
                                   onChange={(e) => onFilterHandler(e, 'sub_category')}/>
                            <label htmlFor={sub_category.product_sub_category_cd}>{sub_category.name}</label>
                        </div>
                    </li>
                );
            })
        }
        if (state.selectedProductBrands && state.selectedProductBrands) {
            localProductBrand = state.selectedProductBrands.filter(x => x.product_category_cd === state.selectedCategory.product_category_cd).map((brand, index) => {
                return (
                    <li key={`${brand.id}${index}`}>
                        <input type="checkbox"
                               id={'brand' + brand.product_brand_cd}
                               checked={brand.is_checked}
                               value={brand.slug}
                               onChange={(e) => onFilterHandler(e, 'brand')}/>
                        <label htmlFor={'brand' + brand.product_brand_cd}>{brand.name}</label>
                    </li>);
            });
        }
        if (state.productCategories) {
            otherCategories = state.productCategories.map((item, index) => {
                return (
                    <li className={[""].join(' ')} key={`${item.id}${index}`}
                        onClick={() => {
                            onRefreshHandler(item.slug, item.id, 0, 0, item.name)
                        }}>
                        <div className={classesFilter.Items_component}>
                            <div className={classesFilter.Items_pipe}/>
                            <div>{item.name.toUpperCase()}</div>
                        </div>
                    </li>
                );
            })
        }
        localProducts = (
            <>
                {/*{state.isNodata && <h1>No Data Found</h1>}*/}
                <ul className={classes.ProductsCard_wrapper}>
                    {currentData.map((prod, index) => {
                        return (
                            <li key={`${prod.id}${index}`} className={classes.Card_container_li}>
                                <Product prod={prod}/>
                            </li>
                        );
                    })}
                </ul>
            </>
        )
    }

    return (
        <>
            <div className={["violet", classes.Page_container].join(' ')} ref={(section) => {
                scrollToComponent.Violet = section;
            }}>
                <Helmet>
                    <meta name="description" content={"JAPFA FOOD: Product Catalog, Poultry, Value Added Meats, Wagyu Beef, Seafood, Dairy, Sauces & Dressings."}/>
                    <meta name="keywords" content={"frozen food, meat shop, Chicken shop, supplier frozen food, food service, Best Chicken, Tokusen, Omayo, food catering, food service delivery, Japfa Indonesia, food solutions, JBFS, Food Supplier"}/>
                    <meta name="author" content=""/>
                    <meta property="og:title" content={state.selectedCategory.name !== undefined
                        ?
                        `${state.selectedCategory.name}${(" Catalog Japfa Food | Indonesia | Food Supplier")}`
                        : 'Product Category | Indonesia | Food Supplier'}/>
                    <meta property="og:description"
                          content={"JAPFA FOOD: Product Catalog, Poultry, Value Added Meats, Wagyu Beef, Seafood, Dairy, Sauces & Dressings."}/>
                    <title>{localStorage.getItem('ct_param_product_category') !== null ?
                        localStorage.getItem('ct_param_product_category') &&
                        localStorage.getItem('ct_param_product_category').concat(" Catalog Japfa Food | Indonesia | Food Supplier")
                        :
                        'Catalog Japfa Food | Indonesia | Food Supplier'
                    }
                    </title>
                    <link rel="canonical" href={window.location.origin.toString() + props.location.pathname}/>
                </Helmet>
                {/*-------------------------------------------------------------------------------------------------*/}
                {/*Bread crumbs region*/}
                <section className={[classes.SearchPage_sectionBread].join(' ')}>
                    <div className={["jbfs-wrapper", classes.Search_wrapperBread].join(' ')}>
                        <div className={["jbfs-breadcrumb-row",].join(' ')}>
                            <HomeBreadcrumb/>
                            <span>/</span>
                            <div>{state.selectedCategory && state.selectedCategory.length < 1 ? (<LoadingSimple size={"small"} position={'left'}/>) : state.selectedCategory.name}</div>
                        </div>
                    </div>
                </section>
                {/*Bread crumbs region*/}

                <section className={[classes.PageHeader_section].join(' ')}>
                    <div className={["jbfs-wrapper", classes.PageHeader_wrapper].join(' ')}>
                        <div className={classes.Description_row}>
                            <div>
                                <h1 className={["jbfs-title-case"].join(' ')}>{(state.selectedCategory && state.selectedCategory.length < 1 ? (<LoadingSimple position={"left"}/>) : state.selectedCategory.name)}</h1>
                                {state.selectedCategory && state.selectedCategory.length < 1 ? (<LoadingSimple/>) : <div className={classes.Description_description} dangerouslySetInnerHTML={{__html: state.selectedCategory.description}}/>}
                            </div>
                            <div className={classes.Cta_component}>
                                {contactUsComponent}
                            </div>
                        </div>
                    </div>
                </section>
                {/*-------------------------------------------------------------------------------------------------*/}
                <section className={classes.PageBody_section}>
                    <div className={["jbfs-wrapper", classes.Content_wrapper_main].join(' ')}>
                        <div className={classes.Content_left}>
                            <div className={["", classesFilter.ProductFilter_container].join(' ')}>
                                <section className={classesFilter.Cta_section}>
                                    <div className={classesFilter.Cta_button} onClick={() => gotoSomewhere()}>
                                        <div className={classesFilter.Cta_pipe}/>
                                        <div style={{textTransform: "uppercase", fontWeight: 'bold'}}>
                                            <FormattedMessage id={"featuredpage.title"} defaultMessage={"FEATURED PRODUCTS"}/>
                                        </div>
                                    </div>
                                </section>
                                {/*-------------------------------------------------------------------------------------------------*/}
                                <section className={classesFilter.Filter_section}>
                                    <div className={classesFilter.SelectedTitle_row}>
                                        <div className={classesFilter.SelectedTitle_pipe}/>
                                        {(state.selectedCategory ? state.selectedCategory.name : '')}
                                    </div>
                                    <div className={classesFilter.ProductFilter_wrapper}>
                                        <div><FormattedMessage id={"prodcategory.sidebar.filtersubcategory"}
                                                               defaultMessage={"Filter by Sub Category"}/></div>
                                        <ul>
                                            {state.selectedSubCategories && state.selectedSubCategories.length < 1 ?
                                                (<LoadingSimple/>)
                                                : localSubCategory}
                                        </ul>
                                        <div><FormattedMessage id={"prodcategory.sidebar.filterbrand"}
                                                               defaultMessage={"Filter by Brand"}
                                        /></div>
                                        <ul>
                                            {state.selectedProductBrands && state.selectedProductBrands.length < 1 ?
                                                (<LoadingSimple/>)
                                                : localProductBrand}
                                        </ul>
                                    </div>
                                </section>
                                {/*-------------------------------------------------------------------------------------------------*/}
                                <section className={classesFilter.Others_section}>
                                    <div className={classesFilter.Others_item}>
                                        <ul>
                                            {state.productCategories && state.productCategories.length < 1 ?
                                                (<LoadingSimple position={'left'}/>)
                                                : otherCategories}
                                        </ul>
                                    </div>
                                </section>
                            </div>
                        </div>
                        {/*-------------------------------------------------------------------------------------------------*/}
                        <div className={classes.Content_wrapperRight}>
                            <CountSortingContainer
                                data={state.products}
                                label={<FormattedMessage id={"global.items.title"} defaultMessage={"items"}/>}
                                options={options}
                                onSortHandler={onSortHandler}
                                defaultOps={state.defaultOps}
                            />
                            {isError && <div>Something went wrong ...</div>}
                            {state.products && state.products.length < 1 ? <h4>Load...</h4> :
                                (
                                    state.products && state.products[0].id === null ? <h1><FormattedMessage id={"global.nodatafound"} defaultMessage={"No data found"}/></h1>
                                        : localProducts
                                )
                            }
                        </div>
                    </div>
                    <div className={["jbfs-wrapper", "jbfs-paging-container", classes.Pagination_container].join(' ')}>
                        {pagination}
                    </div>
                    {isMobileOnly ? (
                        <div className={classes.Mobile_component_container}>
                            {state.productCategories && state.productCategories.length < 1 ?
                                (<LoadingSimple position={'left'}/>)
                                : <CategoriesHook data={undefined}
                                                  product_categories={state.productCategories}
                                                  goRefresh={onRefreshHandler}/>
                            }
                        </div>
                    ) : ''}
                </section>
                {/*-------------------------------------------------------------------------------------------------*/}
                <div className={"jbfs-arrow-top"}>
                    <JIcon icontype={"link_to_top"} onClick={() => utilScrollUp()}/>
                </div>
            </div>
        </>
    )
}

export default ProductCategoryPageHook